<div>
  <div class="row mt-0 pt-0">

    <div class="col-md-12 col-lg-6 px-1 pb-2" *ngFor="let fa of vm.fileEntries">
      <app-file-entry [vm]="fa" [actions]="vm"></app-file-entry>
    </div>

    <div class="col-md-12 col-lg-6 px-1 text-center" *ngIf="vm.fileEntries.length == 0">
      <div>
        <span class="text-danger">{{fileLoadError}}</span>
      </div>
      <div>
        <mdb-file-upload #uploader [height]="100" (fileAdded)="onFileAdd($event)">
        </mdb-file-upload>
      </div>
    </div>
  </div>

</div>

